
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ModuleCard } from '@/components/parts/modules';
import { IModule } from './types';

@Component({
  components: {
    ModuleCard,
  },
})
export default class ComponentsPartsCatalogCardComponentsTabsModuleLayout
  extends Vue
  implements IModule {
  // Props
  @Prop({ type: Object, default: () => {} })
  item: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/modules/components/module/Module.vue